import React, { useState } from 'react';
import DspxModal from '../../../common/DspxModal/DspxModal';
import OneFieldForm from '../../forms/OneFieldForm/OneFieldForm';
import ModalSubtitle from '../../ModalSubtitle/ModalSubtitle';

const OneFieldFormModal = ({
  form,
  initialValue,
  fieldType = 'text',
  onCancel,
  onSubmit,
  subtitle,
  label,
  inputName,
  requiredErrMsg,
  validationTypes = [],
  inputProps,
  numberComparison = false,
  ...props
}) => {
  const { resetFields, validateFieldsAndScroll } = form;

  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleCancel = () => {
    onCancel();
    resetFields();
  };

  const handleSubmit = () => {
    validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        setConfirmLoading(true);
        await onSubmit(values);
        setConfirmLoading(false);
        handleCancel();
      }
    });
  };

  return (
    <DspxModal
      onCancel={handleCancel}
      confirmLoading={confirmLoading}
      onOk={handleSubmit}
      bodyStyle={{ padding: '24px 24px 14px' }}
      {...props}
    >
      <ModalSubtitle subtitle={subtitle} />
      <OneFieldForm
        form={form}
        initialValue={initialValue}
        fieldType={fieldType}
        label={label}
        name={inputName}
        requiredErrMsg={requiredErrMsg}
        validationTypes={validationTypes}
        inputProps={inputProps}
        numberComparison={numberComparison}
      />
    </DspxModal>
  );
};

export default OneFieldFormModal;
